import { apiEndPointType, routMapType } from "./config.types";
import { QueryClient } from "@tanstack/react-query";
export const queryClient = new QueryClient();
// const host: string = "";
const prod: string = "https://backendtest.varahaag.com";
const host: string = prod;

export const TOAST_AUTO_CLOSE_TIME: number = 15000;
export const XClient_ID: string = "partner_app";
//Map box  token
export const MAP_BOX_TOKEN =
  "pk.eyJ1IjoidmlzaGFsLWt1Y2hhbnVyIiwiYSI6ImNsbm1zcDlqNjJreWsybHJsbnptNTJ3cHgifQ.l6VV1JFdeoS0E_rfF-Y5Xw";
//map box style for summary page
export const MAP_BOX_STYLE: string =
  "mapbox://styles/vishal-kuchanur/cll4zw1nz00ia01pib7ah4ela";
export const SENTRY_URL =
  "https://4ed6848d6b9bae75de62c58477de5989@o4506194417614848.ingest.sentry.io/4506194573066240";
export const environment = "production";
//api end point helper objects for the application
export const apiEndPoints: apiEndPointType = {
  LOGIN_API: host + "/api/web/login/",
  RESET_API: host + "/user-profile/password_reset/",
  PASSWORD_CHANGE: host + "/user-profile/password_change/",
  LINK_EXPIRY_CHECK: host + "/user-profile/reset_password_link_expired/",
  SUMMARY_INSIGHTS: host + "/api/web/partner/v1/farmer/dashboard/insights/",
  SUMMARY_API_FARMER: host + "/api/web/partner/v1/trend/farmer/",
  SUMMARY_API_FARM: host + "/api/web/partner/v1/trend/farm/",
  SUMMARY_API_FARMCROP: host + "/api/web/partner/v1/trend/farmcrop/",
  SUMMARY_API_FARMSPECIES: host + "/api/web/partner/v1/trend/farmspecies/",
  SUMMARY_API_AREA: host + "/api/web/partner/v1/trend/farmarea/",
  SUMMARY_API_CROPACTIVITIES:
    host + "/api/web/partner/v1/farmer/dashboard/activities/farmcrop/",
  SUMMARY_API_FARMACTIVITIES:
    host + "/api/web/partner/v1/farmer/dashboard/activities/farm/",
  SUMMARY_API_FARMERACTIVITIES:
    host + "/api/web/partner/v1/farmer/dashboard/activities/farmer/",
  SUMMARY_API_CENTRIOID: host + "/api/web/partner/v1/farms/centroid/",
  SUMMARY_API_DISTRIBUTION: host + "/api/web/partner/v1/farms/distribution/",
  SUMMARY_API_STATUS_FARM: host + "/api/web/partner/v1/stats/farm/",
  SUMMARY_API_STATUS_FARMER: host + "/api/web/partner/v1/stats/farmer/",
  SUMMARY_API_STATUS_CROP: host + "/api/web/partner/v1/stats/farmcrop/",
  SUMMARY_API_TOPAGENT: host + "/api/web/partner/v1/farmer/dashboard/topagent/",
  LOGOUT: host + "/api/web/logout/",
  USER_PROFILE: host + "/api/web/user/details/",
  SUPER_SET: host + "/api/web/user/superset/token/",
  MANAGE_FARMERS: host + "/api/web/partner/v1/farmer/all/",
  COUNTRY: prod + "/core/country/",
  STATE: prod + "/core/state",
  DISTRICT: prod + "/core/district",
  BLOCK: prod + "/core/block",
  ORG_AGENT: host + "/api/web/org/user/",
  manage_farm_status: host + "/api/web/partner/v1/farmer/farm/",
  manage_farm_status_arr: host + "/api/web/partner/v1/farmer/ag_farm/",
  GOOGLE_SIGNIN_API: host + "/api/web/google/authenticate/",
  manage_surveyor_active: host + "/api/web/partner/v1/trend/surveyor/",
  manage_surveyor_totalSurveys: host + "/api/web/partner/v1/trend/surveysdone/",
  manage_surveyor_data: host + "/api/web/partner/v1/surveyor/all/",
  manage_surveyor_deactivate: host + "/api/web/partner/v1/surveyor/otp/",
  manage_surveyour_validateOtp:
    host + "/api/web/partner/v1/surveyor/deactivate/",
  manage_surveyor_addagent: host + "/api/web/partner/v1/surveyor/register/otp/",
  manage_surveyor_validate: host + "/api/web/partner/v1/surveyor/register/",
  manage_surveyor_validate_user: host + "/user-profile/check_username/",
  manage_surveyor_validate_email: host + "/user-profile/check_user_email/",
  manage_surveyor_validate_phone:
    host + "/user-profile/check_user_phone_number/",
  manage_surveyor_validate_aadhar:
    host + "/user-profile/check_user_aadhaar_number/",
};

//pagination size;
export const paginationSize = 20;
//items per page as per api
export const totalPageSize = 100;
// constant multiplier to handle pages count shown in the UI
export const pageMultiplier = 5;

//helper object for LayoutHeader Component
export const routeMap: routMapType = {
  summary: "Overview",
  "manage-farmers": "Manage Farmers",
  reports: "Custom Reports",
  "manage-surveyors": "Manage Survey Agents",
  payments: "Payments",
};
//------------------------------------------------------------------------------------------------------------------------------------------------
//helper objects for computeWeeklyStat function in Summary module,
export const weekMap: { [key: string]: string } = {
  0: "Sun",
  1: "Mon",
  2: "Tue",
  3: "Wed",
  4: "Thur",
  5: "Fri",
  6: "Sat",
};
//helper objects for computeHalfYearStat function in Summary module,
export const montNameMap: { [key: string]: string } = {
  0: "Jan",
  1: "Feb",
  2: "Mar",
  3: "Apr",
  4: "May",
  5: "Jun",
  6: "Jul",
  7: "Aug",
  8: "Sep",
  9: "Oct",
  10: "Nov",
  11: "Dec",
};
//------------------------------------------------------------------------------------------------------------------------------------------------
/**
 *
 * @param {string}str
 * @returns {string}
 */
export const convertToTitleCase = (str: string) =>
  str
    ? str
        .split(" ")
        .map((e) => (e[0] ? e[0]?.toUpperCase() + e.slice(1, e.length) : e))
        .join(" ")
    : "";
/**
 *
 * @returns void
 */
export const getLoginStatus = () => localStorage.getItem("login") === "true";

/**
 * @returns {object}
 * clear local storage
 */
export const clearStorage = () => {
  localStorage.removeItem("login");
  localStorage.removeItem("superset_token");
  localStorage.removeItem("superset_token_expiry");
  localStorage.removeItem("welcommessageShown");
  queryClient.removeQueries();
};

//Google Auth Client Id
export const VITE_GOOGLE_OAUTH_CLIENT_ID =
  "14233977189-7t4mafepugl8pdqbgsoivm78aec5srag.apps.googleusercontent.com";

export const REGX = {
  phoneNumberPattern: /^\d{5,15}$/,
  aadharNumberPattern: /^\d{12}$/,
  emailPattern: /^[^\s@]+@[^\s@]+\.[^\s@]+$/,
  passwordRegx: /^(?=.*[a-zA-Z])(?=.*[^a-zA-Z0-9]).{8,}$/,
};

export function detectBrowser() {
  const userAgent = navigator.userAgent;

  if (/chrome|crios|crmo/i.test(userAgent)) {
    return "Chrome";
  } else if (/firefox|iceweasel|fxios/i.test(userAgent)) {
    return "Firefox";
  } else if (
    /safari/i.test(userAgent) &&
    !/chrome|crios|crmo/i.test(userAgent)
  ) {
    return "Safari";
  } else if (/edg/i.test(userAgent)) {
    return "Edge";
  } else if (/opr|opera/i.test(userAgent)) {
    return "Opera";
  } else if (/msie|trident/i.test(userAgent)) {
    return "Internet Explorer";
  } else {
    return "Unknown";
  }
}
